import { NavigateBackButton } from 'components/Blocks/Product/AddToCartPopup/NavigateBackButton';
import { PopupLayout } from 'components/Blocks/Product/AddToCartPopup/PopupLayout';
import { ProductListRow } from 'components/Pages/Configurator/Popup/ProductList/ProductListRow';
import { groupProductsInDrawer } from 'helpers/configurator/configuratorHelpers';
import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';
import { usePersistStore } from 'store/usePersistStore';
import { ConfiguratorProductTypeSummed } from 'types/configurator';

type ProductListPopupProps = {
    onCloseCallback?: () => void;
};

export const ProductListPopup: FC<ProductListPopupProps> = ({ onCloseCallback }) => {
    const { t } = useTranslation();
    const { productsInDrawer } = usePersistStore();
    const productsInDrawerSummed: ConfiguratorProductTypeSummed[] = useMemo(() => {
        return groupProductsInDrawer(productsInDrawer);
    }, [productsInDrawer]);
    const totalProductsInDrawer = productsInDrawer.length;

    return (
        <PopupLayout
            heading={
                <>
                    {t('Product list')}{' '}
                    <span className="ml-2 font-normal">({t('{{ count }} pcs', { count: totalProductsInDrawer })})</span>
                </>
            }
        >
            {productsInDrawerSummed.map((product, index) => (
                <ProductListRow key={index} product={product} />
            ))}
            <div className="flex items-center justify-center">
                <NavigateBackButton onCloseCallback={onCloseCallback} />
            </div>
        </PopupLayout>
    );
};
